import {
  Avatar,
  AvatarGroup,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
  Select,
  TextField,
  TextareaAutosize,
  Typography,
  Skeleton,
  IconButton
} from "@mui/material";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../util/firebase";
import Chat from "./Chat";
import {FileUpload, Button, FileViewer} from "../components";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { nanoid } from "nanoid";
import {
  fetchGet,
  fetchPost,
  fetchPut,
  handleUpload,
  idGenerator,
  convertDate,
  transformFirebaseTime,
  fetchFile
} from "../util/helpers";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { ArrowDropDown, ArrowDropDownCircle, OpenInNew, Download } from "@mui/icons-material";
import Analytics from "./Analytics";
import UserContext from "../contexts/UserContext";
import LoadingContext from "../contexts/LoadingContext";
import "./Workstream.css"
import { DataGrid } from "@mui/x-data-grid";


import { registerLicense } from '@syncfusion/ej2-base';
import { DocumentEditorContainerComponent, Toolbar, SfdtExport, WordExport } from '@syncfusion/ej2-react-documenteditor';
registerLicense("Ngo9BigBOggjHTQxAR8/V1NAaF1cVGhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEFjUX5acXdWQ2NVWUJ/Ww==")
DocumentEditorContainerComponent.Inject(Toolbar, SfdtExport, WordExport);

export default function Workstream() {
  const [campaign, setCampaign] = useState({});

  const [creators, setCreators] = useState([]);
  const [selectedCreator, setSelectedCreator] = useState({});
  const [trackingModalOpen, setTrackingModalOpen] = useState(false);
  const [productURL, setProductURL] = useState("");
  const [products, setProducts] = useState([]);
  const [concept, setConcept] = useState("");
  const [deliverable, setDeliverable] = useState([]);
  const [brief, setBrief] = useState("");
  const [agreement, setAgreement] = useState("");
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [invoiceEditorId, setInvoiceEditorId] = useState(0);
  const editorMutableRef = useRef();
  const { campaignId } = useParams();
  const { user } = useContext(UserContext);
  const { setIsLoading, setLoadingText } = useContext(LoadingContext);
  const [briefLoaded, setBriefLoaded] = useState(false);
  const [briefModalOpen, setBriefModalOpen] = useState(false);
  const [briefURL, setBriefURL] = useState("");
  const iframeRef = useRef(null);
  const briefInterval = useRef();

  const [isReviewOpen, setIsReviewOpen] = useState(false);
  const [postLinkList, setPostLinkList] = useState([]);
  const [approveContent, setApproveContent] = useState({ approved: false });
  const [approveConcept, setApproveConcept] = useState({ approved: false });
  const [feedback, setFeedbak] = useState("");
  const [feedbackList, setFeedbackList] = useState([]);



  const clearCheckingInterval = () => {
    clearInterval(briefInterval.current);
  };

  const navigate = useNavigate();

  const getCompanyUploadedDeliverables = async () => {
    const results = await fetchGet(
      `/brand/deliverables?campaignId=${campaignId}&deliveredBy=${user.userDocId}`,
    );
    if (results.result) {
      const tempFeedbackList = [];
      results.result.forEach((item) => {
        if (item.platform === "creator-agreement") {
          setAgreement(item.link);
        } else if (item.platform === "creator-brief") {
          setBrief(item.link);
        }
      });
      const creatorReviews = results.result.filter((data)=>data.creatorId !== undefined && data.creatorId === selectedCreator.userDocId);
      if(creatorReviews.length > 0){
        creatorReviews.forEach((item)=>{
          if (item.platform === "Approve-Content")setApproveContent({ ...item });
          else if(item.platform === "Approve-Concept")setApproveConcept({ ...item }); 
          else if (item.platform === "Creator-Feedback") {
            tempFeedbackList.push({ ...item, submittedAt: new Date(item.submittedAt._seconds * 1000 + item.submittedAt._nanoseconds / 1000000) });
          }
        })
      }else{
        setApproveContent({approved:false});
        setApproveConcept({approved:false});
      }
      tempFeedbackList.sort((a,b)=>b.submittedAt - a.submittedAt)
      setFeedbackList([...tempFeedbackList]);
    }
  };
  const getAllDeliverables = async () => {
    const results = await fetchGet(
      `/brand/deliverables?campaignId=${campaignId}&deliveredBy=${selectedCreator.userDocId}`,
    );
    if (results.result) {
      const resultDeliverables = [];
      const postLinks = [];
      results.result.forEach((item) => {
        if (item.platform === "concept") {
          setConcept(item.link);
        } else if (item.platform === "draft") {
          resultDeliverables.push({...item});
        } else {
          postLinks.push({...item})
        }
      });
      resultDeliverables.sort((a, b) => transformFirebaseTime(a.submittedAt) - transformFirebaseTime(b.submittedAt))
      setDeliverable([...resultDeliverables]);
      setPostLinkList([...postLinks]);

    }
  };

  const onIframeLoaded = () => {
    clearCheckingInterval();
    setBriefLoaded(true);
  };

  const generateBrief = async () => {
    setLoadingText("Generating brief");
    fetchPost(
      "/brand/brief/generate",
      {
        campaignId: campaignId,
        brandName: campaign.brand,
        campaignName: campaign.name,
        campaignDeliverables: campaign.deliverables,
        campaignDetails: campaign.description,
        campaignTalkingPoints: campaign.talking_points,
        campaignWrittenTimeline: campaign.written_due,
        campaignDraftTimeline: campaign.draft_due,
        campaignFinalTimeline: campaign.final_due,
      },
      setIsLoading,
    )
      .then(() => {
        const storage = getStorage();
        getDownloadURL(ref(storage, `briefs/${campaignId}.docx`)).then(
          (url) => {
            setBriefURL(url);
            setBriefModalOpen(true);
          },
        );
      })
      .catch((err) => {
        console.log("error", err);
        alert("An error occured generating the brief");
      });
  };

  const resetFields = () => {
    setAgreement("");
    setBrief("");
    setConcept("");
    setDeliverable([]);
  };
  const onLoadDefault = (ref) => {
    // tslint:disable
    let defaultDocument = {
      sfdt: "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",
    };
    // tslint:enable
    ref.documentEditor.open(JSON.stringify(defaultDocument));
    ref.documentEditor.documentName = "Invoice";
    ref.documentChange = () => {
      ref.documentEditor.focusIn();
    };
  };
  const editorRef = useCallback(
    (ref) => {
      const rendereComplete = () => {
        editorMutableRef.current = ref;
        ref.documentEditor.pageOutline = "#E0E0E0";
        ref.documentEditor.acceptTab = true;
        ref.documentEditor.resize();
        onLoadDefault(ref);
      };
      if (invoiceModalOpen && ref) {
        rendereComplete();
      }
    },
    [invoiceModalOpen],
  );
  useEffect(() => {
    const fetchCampaign = async () => {
      if (campaignId) {
        const response = await fetchGet(`/brand/campaigns/${campaignId}`);
        if (response.result) {
          setCampaign(response.result);
        }
      }
    };

    const fetchCreators = async () => {
      if (campaignId) {
        const result = await fetchGet(`/brand/campaigns/${campaignId}/matches`);
        setCreators(result.result);
        setSelectedCreator(result.result ? result.result[0] : {});
      }
    };
    fetchCampaign();
    fetchCreators();
    getAllDeliverables();
    getCompanyUploadedDeliverables();
  }, [campaignId]);

  const fetchProducts = async () => {
    if (campaignId && selectedCreator) {
      const results = await fetchGet(
        `/product/redirect?campaignId=${campaignId}&creatorUserDocId=${selectedCreator.userDocId}`,
      );
      setProducts(results.result);
    }
  };
  useEffect(() => {
    fetchProducts();
    resetFields();
    getAllDeliverables();
    getCompanyUploadedDeliverables();
    setIsReviewOpen(false)
  }, [campaignId, selectedCreator]);
  const handleCloseProductModal = () => {
    setTrackingModalOpen(false);
    setProductURL("");
  };
  const handleGenerateURL = async () => {
    await fetchPost(`/product/redirect`, {
      productURL,
      campaignId,
      creatorUserDocId: selectedCreator.userDocId,
    });
    await handleCloseProductModal();
    await fetchProducts();
  };
  const handleAddFile = async (url, type) => {
    return fetchPost(`/brand/deliverables`, {
      campaignId: campaignId,
      platform: type,
      link: url,
    });
  };

  const handleDownloadInvoice = () => {
    if (editorMutableRef.current) {
      editorMutableRef.current.documentEditor.save("invoice", "Docx");
    }
  };

  const columns = useMemo(
    () => [
      {
        field: "srNo", headerName: "Sr. No", width: 70, valueGetter: (params) => {
          const rowIndex = params?.api?.getAllRowIds()?.indexOf(params?.id?.toString());
          return rowIndex + 1;
        }
      },
      { field: "platform", headerName: "Platform", flex: .5 },
      { field: "link", headerName: "Link", flex: 1, renderCell: (params) => [<a href={params.value} target="_blank" style={{ color: "black", textDecoration: "none" }}>{params.value}</a>] },
      {
        field: "actions",
        type: "actions",
        flex: .3,
        sortable: false,
        getActions: (params) => [
          <a href={params.row.link} target="_blank" style={{ color: "black", textDecoration: "none" }}>
            <IconButton
              style={{
                backgroundColor: "#4158D0",
                backgroundImage:
                  "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
                borderRadius: 20,
                fontSize: 14,
              }}
              onClick={() => {
              }}
            >
              <OpenInNew />
            </IconButton></a>
        ],
      }
    ]
  );

  const approveConceptContent = async (type, status) => {
    const id = (type === "Approve-Concept") ? approveConcept.id : approveContent.id;
    const reqBody = {
      campaignId: campaignId,
      platform: type,
      approved: status,
      creatorId: selectedCreator.userDocId
    }
    const result = id ? await fetchPut(`/brand/deliverables/${id}`, {...reqBody}) : await fetchPost(`/brand/deliverables`, {...reqBody})
    if (type === "Approve-Content") setApproveContent({ ...result.data }); else setApproveConcept({ ...result.data });
  }

  const submitFeedback = async () => {
    const result = await fetchPost(`/brand/deliverables`, {
      campaignId: campaignId,
      platform: "Creator-Feedback",
      feebback: feedback,
      creatorId: selectedCreator.userDocId
    });
    getCompanyUploadedDeliverables();
    setFeedbak("");

  }

  const handleDownloadDeliverables = async (fileUrl, fileName) => {
    const sourceFile = await fetchFile(fileUrl);
    const url = window.URL.createObjectURL(sourceFile);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  return (
    <Box marginBottom={10}>
      <Dialog
        open={invoiceModalOpen}
        fullWidth
        onClose={() => setInvoiceModalOpen(false)}
        maxWidth="lg"
      >
        <DialogTitle>Generate an invoice with our template</DialogTitle>
        <DialogContent sx={{ height: "80vh" }}>
          <DocumentEditorContainerComponent 
        ref={editorRef}
        id={`doc-editor`} height={`${window.innerHeight * 0.7}px`} style={{ 'width': '100%' }} serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/documenteditor/" enableToolbar={true}
        enableWordExport
        locale="en-US"
        />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDownloadInvoice}>Download</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={briefModalOpen}
        fullWidth
        onClose={() => setBriefModalOpen(false)}
        key={`dialog-${briefURL}`}
      >
        <DialogTitle>Generated Brief</DialogTitle>
        <DialogContent>
          <Typography style={{ marginBottom: 20 }}>
            <a href={briefURL} rel="noopener noreferrer" target="_blank">
              Download Your Modifiable Brief
            </a>
          </Typography>
          {!briefLoaded && (
            <Skeleton
              width="100%"
              height={600}
              variant="rectangular"
              animation="wave"
            />
          )}
          <iframe
            ref={iframeRef}
            title="file"
            width="100%"
            height="600"
            onLoad={onIframeLoaded}
            src={
              "https://docs.google.com/viewer?url=" +
              encodeURIComponent(briefURL) +
              "&embedded=true"
            }
          ></iframe>
        </DialogContent>

        <DialogContent>
        </DialogContent>
      </Dialog>

      <Dialog
        open={trackingModalOpen}
        fullWidth
        onClose={handleCloseProductModal}
      >
        <DialogTitle>Create a Tracking Link</DialogTitle>
        <DialogContent>
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            Your Product URL
          </Typography>
          <TextField
            fullWidth
            onChange={(e) => setProductURL(e.target.value)}
          ></TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleGenerateURL}>Generate</Button>
        </DialogActions>
      </Dialog>
      <div
        style={{
          width: "100%",
          height: "100%",
          background: "black",
          textAlign: "left",
          color: "white",
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <Typography
          variant="h2"
          component="div"
          style={{ color: "white", marginLeft: "10vw" }}
        >
          {campaign.brand} x{" "}
          <Select
            label=""
            value={selectedCreator || {}}
            renderValue={(val) => val.name}
            onChange={(e) => {
              setSelectedCreator(e.target.value);
            }}
            IconComponent={() => (
              <ArrowDropDown fontSize="large" sx={{ color: "white" }} />
            )}
            sx={{
              color: "white",
              fontSize: "3.75rem",
              fontWeight: 300,
              borderBottom: "2px solid #ced4da",
              minWidth: 200,
            }}
          >
            {creators.map((creator) => (
              <MenuItem value={creator} key={creator.id}>
                {creator.name}{" "}
              </MenuItem>
            ))}
          </Select>
        </Typography>
      </div>
      <Button
        variant="text"
        style={{ color: "black", float: "left", marginLeft: 20 }}
        onClick={() => navigate(`/campaigns/${campaignId}`)}
      >
        <ArrowBackIosIcon />
        Back to Campaign Details
      </Button>
      <Grid container spacing={2} style={{ marginTop: 20 }}>
        <Grid item xs={4}>
          <Chat
            style={{ width: "100%", marginLeft: 20, marginBottom: 40 }}
            campaignId={campaignId}
            creatorId={selectedCreator.userDocId}
          />

          <Grid
            container
            sx={{
              margin: "0 auto",
              textAlign: "center",
            }}
            alignItems="center"
            justifyContent="center"
            style={{
              backgroundColor: "black",
              minHeight: 10,
              marginTop: 50,
              marginBottom: 50,
              marginLeft: 18,
            }}
          ></Grid>

          <Typography
            variant="h5"
            style={{
              textAlign: "left",
              marginTop: 40,
              fontWeight: 800,
              marginLeft: 20,
              marginBottom: 10,
            }}
          >
            Want to Send a Reminder?
          </Typography>
          <Typography
            variant="body"
            style={{ textAlign: "left", marginLeft: 20, marginBottom: 40 }}
          >
            Send this creator an email on this collaboration.
          </Typography>

          <Button
            style={{
              borderRadius: 1,
              width: "90%",
              marginBottom: 10,
              marginLeft: 20,
              fontSize: 12,
              borderRadius: 6,
              backgroundColor: "black",
              marginTop: 20,
            }}
            href={`mailto:${selectedCreator.email}?subject=Gigl: New Campaign Partnership Opportunity`}
          >
            Send a Custom Email
          </Button>

          <Typography
            variant="h5"
            style={{
              textAlign: "left",
              marginTop: 40,
              fontWeight: 800,
              marginLeft: 20,
              marginBottom: 10,
            }}
          >
            Skip the Paperwork, Powered by AI
          </Typography>

          <Typography
            variant="body"
            style={{ textAlign: "left", marginLeft: 20, marginBottom: 40 }}
          >
            Generate Custom Documents on Gigl.
          </Typography>

          <Button
            style={{
              borderRadius: 1,
              width: "90%",
              marginBottom: 10,
              marginLeft: 20,
              fontSize: 14,
              borderRadius: 6,
              marginTop: 20,
              backgroundColor: "#4158D0",
              backgroundImage:
                "linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%)",
            }}
            onClick={generateBrief}
          >
            Generate Creator Brief
          </Button>

          <Button
            onClick={() => setInvoiceModalOpen(true)}
            style={{
              borderRadius: 1,
              width: "90%",
              marginBottom: 10,
              marginLeft: 20,
              fontSize: 14,
              borderRadius: 6,
              marginTop: 20,
              backgroundColor: "#4158D0",
              backgroundImage:
                "linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%)",
            }}
          >
            Generate Invoice
          </Button>
        </Grid>

        <Grid item xs={7} style={{ margin: "0 auto" }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 800, textAlign: "left", marginBottom: 10 }}
          >
            Collaborating with {selectedCreator.name}
          </Typography>

          {selectedCreator.description && (
            <Typography
              variant="body2"
              style={{ textAlign: "left", marginBottom: 20 }}
            >
              About: {selectedCreator.description}
            </Typography>
          )}

          <div>
            {selectedCreator.images &&
              selectedCreator.images.map((img, index) => (
                <img
                  src={img}
                  height={"100px"}
                  width={"100px"}
                  style={{
                    marginRight:
                      index === selectedCreator.images.length - 1 ? 0 : "40px",
                    borderRadius: 5,
                    objectFit: "cover",
                  }}
                />
              ))}
          </div>

          <Grid
            container
            sx={{
              margin: "0 auto",
              textAlign: "center",
            }}
            alignItems="center"
            justifyContent="center"
            style={{
              backgroundColor: "black",
              minHeight: 10,
              marginTop: 50,
              marginBottom: 50,
            }}
          ></Grid>

          <Typography
            variant="h5"
            style={{ fontWeight: 800, textAlign: "left", marginBottom: 10 }}
          >
            Upload Creator Brief & Additional Documents
          </Typography>

          {brief && (
            <>
              Uploaded:{" "}
              <a href={brief} target="_blank" rel="noreferrer">
                Document
              </a>
            </>
          )}

          <FileUpload
            containerProps={{
              style: { width: "100%", marginBottom: 20, textAlign: "center" },
            }}
            handleFilesChange={async (files) => {
              if (files !== null && files?.length > 0) {
                const file = files[0];
                const fileId = idGenerator();
                const fileExtension = file.name.split('.').pop();
                const url = await handleUpload(
                  file,
                  "creator-brief",
                  `campaign-${campaignId}-${fileId}.${fileExtension}`,
                );
                await handleAddFile(url, "creator-brief");
                await getAllDeliverables();
              }
            }}
          />
          <Typography
            variant="h5"
            style={{ fontWeight: 800, textAlign: "left", marginBottom: 10 }}
          >
            Creator Concept
          </Typography>
          <TextareaAutosize
            value={concept}
            disabled
            fullWidth
            style={{
              minWidth: "100%",
              maxWidth: "100%",
              padding: 10,
              backgroundColor: "#fdf5e6",
              borderRadius: 6,
            }}
            minRows={5}
            placeholder="Waiting for the creator"
          />
          <Typography
            variant="h5"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginBottom: 10,
              marginTop: 10,
            }}
          >
            Deliverables & Captions
          </Typography>
          {
            deliverable.length === 0 && <TextareaAutosize
            value={concept}
            disabled
            fullWidth
            style={{
              minWidth: "100%",
              maxWidth: "100%",
              padding: 10,
              backgroundColor: "#fdf5e6",
              borderRadius: 6,
            }}
            minRows={5}
            placeholder="Waiting for the creator"
          />
          }
          {deliverable.map((row, index) => {
              const fileUrl = row.file || row.link;
              return fileUrl ? <>
                <div style={{ display: "flex", width: "100%", justifyContent: "space-between", paddingTop: "2rem" }}>
                  <div style={{ width: "15%" }}>
                    <FileViewer url={fileUrl} />
                    <div style={{ width: "100%", textAlign: "center", cursor: "pointer", color: "blue", textDecoration: "underline", display: "flex", justifyContent: "center" }}><div onClick={() => { handleDownloadDeliverables(fileUrl, `${campaign.brand}_${selectedCreator.name}_DeliverablesFile${index + 1}`) }}>File {index + 1}</div><Download /></div>
                  </div>
                  <div style={{ width: "85%", paddingLeft: "1em" }}>
                    <TextareaAutosize
                      disabled
                      fullWidth
                      style={{
                        minWidth: "100%",
                        maxWidth: "100%",
                        padding: 10,
                        backgroundColor: "#fdf5e6",
                        borderRadius: 6,
                        cursor: "pointer"
                      }}
                      minRows={4}
                      value={row.caption}
                    />
                  </div>
                </div>
              </> : <div>
                <TextareaAutosize
                  value={row.link}
                  fullWidth
                  style={{
                    minWidth: "100%",
                    maxWidth: "100%",
                    padding: 10,
                    borderRadius: 6,
                    marginTop: 20,
                    backgroundColor: "#fdf5e6",
                  }}
                  minRows={5}
                  placeholder="Add your deliverables"
                  disabled
                />
              </div>
            })}

          <div style={{ display: "flex", flexDirection: "row", alignContent: "center", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <Typography
                variant="h5"
                style={{
                  fontWeight: 800,
                  textAlign: "left",
                  marginTop: 20,
                }}
              >
                Content Review Center
              </Typography>
              <Typography
                variant="body"
                style={{ textAlign: "left", marginBottom: 40, color: "gray" }}
              >
                Approve content, review, and share feedback
              </Typography>
            </div>
            <Button
              style={{

                width: "31%",
                height: 45,
                borderRadius: 6, fontSize: 12,


              }}
              onClick={() => { setIsReviewOpen(!isReviewOpen) }}
            >
              {isReviewOpen ? "Close Review Center" : "Open Review Center"}
            </Button>
          </div>

          <div className={`review-center ${isReviewOpen && "opened"}`}>
            <div className="row" style={{justifyContent:"space-between", marginBottom:"1rem"}}>
              <Typography
                variant="body"
                style={{ textAlign: "left" }}
              >
                Approve Concept
              </Typography>
              {
                approveConcept.approved ? <Button style={{ borderRadius: 6, fontSize: 12, width: "30%", backgroundColor: "#4158D0", backgroundImage: "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)", color: "white", }} onClick={() => approveConceptContent("Approve-Concept", false)}>Approved</Button> : <Button style={{ width: "30%", borderRadius: 6, fontSize: 12, }} onClick={() => approveConceptContent("Approve-Concept", true)}>Approve</Button>
              }
            </div>
            <div className="row" style={{justifyContent:"space-between", marginBottom:"1rem"}}>
              <Typography
                variant="body"
                style={{ textAlign: "left" }}
              >
                Approve Content Deliverables
              </Typography>

              {
                approveContent.approved ? <Button style={{ borderRadius: 6, fontSize: 12, width: "30%", backgroundColor: "#4158D0", backgroundImage: "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)", color: "white",
                }} onClick={() => approveConceptContent("Approve-Content", false)}>Approved</Button> : <Button style={{ width: "30%", borderRadius: 6, fontSize: 12, }} onClick={() => approveConceptContent("Approve-Content", true)}>Approve</Button>
              }

            </div>
            <Typography
              variant="body"
              style={{
                fontWeight: 800,
                textAlign: "left",
                marginTop: 40,
                marginBottom: 20,
                display:"flex",
                alignItems:"center"

              }}
            >
              Share Feedback/Notes
            </Typography>
            <TextareaAutosize placeholder="Enter your feedback..." value={feedback} onChange={(e) => setFeedbak(e.target.value)} minRows={5} className="row"></TextareaAutosize>
            <div className="right-content" style={{marginTop:"1rem"}}>
              <Button style={{ width: "30%",marginBottom: 20,                 borderRadius: 6,
                fontSize: 12, }} onClick={() => { submitFeedback() }}>Submit Feedback</Button>

            </div>
            {
              feedbackList.length > 0 && <>
                <Typography
                  variant="body"
                  style={{
                    fontWeight: 800,
                    textAlign: "left",
                    display:"flex",
                    width:"100%",
                    marginBottom:"1rem"
                  }}
                >
                  Previous Feedback Notes
                </Typography>
                {
                  feedbackList.map((data) => <div style={{marginBottom:20}}>
                    <TextareaAutosize style={{width:"100%"}} minRows={5} value={data.feebback} disabled></TextareaAutosize>
                    <div className="right-content">
                      <Typography variant="body">
                        {convertDate(data.submittedAt)}
                      </Typography>

                    </div>
                  </div>)
                }
              </>
            }

          </div>
          {postLinkList.length > 0 && (

            <div style={{ height: "400px", width: "100%", marginBottom: 80 }}>

            <Typography
            variant="h5"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginBottom: 10,
              marginTop: 50,
            }}
            >
            Live Post Links
            </Typography>
            
            <DataGrid
              rows={postLinkList}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 20 },
                },
              }}
              pageSizeOptions={[20, 50, 100]}
            /> 
            </div>

          )}

        </Grid>

        <Grid
          container
          sx={{
            margin: "0 auto",
            textAlign: "center",
          }}
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: "black",
            minHeight: 10,
            marginTop: 100,
            marginBottom: 30,
          }}
        ></Grid>

        <Grid item xs={8} style={{ marginLeft: 30 }}>
          <Typography
            variant="h5"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginTop: 20,
              marginBottom: 10,
              marginLeft: 20,
            }}
          >
            Your Affiliate Product Tracking Link
          </Typography>
          <Typography
            variant="body1"
            style={{ textAlign: "left", marginLeft: 20 }}
          >
            Generate your custom product tracking link here, and start measuring
            conversions.
          </Typography>
          <Typography
            variant="body1"
            style={{ textAlign: "left", marginLeft: 20 }}
          >
            Input your product site url, and generate a shortened product link
            that you can share with creators.
          </Typography>
        </Grid>
        <Button
          style={{
            width: "90%",
            marginTop: 40,
            marginBottom: 20,
            marginLeft: 20,
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            textAlign: "center",
            float: "right",
            maxWidth: 300,
            marginLeft: 10,
          }}
          onClick={() => setTrackingModalOpen(true)}
        >
          Create
        </Button>
        {products.map((product) => (
          <TextField
            key={product.id}
            sx={{ width: "60%", marginLeft: 8, marginTop: 5 }}
            value={`https://giglgroup.com/product/${product.id}`}
          />
        ))}
      </Grid>
      <Analytics
        campaignId={campaignId}
        creatorId={selectedCreator.userDocId}
      />
    </Box>
  );
}